import Vue from 'vue'
import axios from 'axios'
import Store from '@/store'
import * as Cookie from 'tiny-cookie'

const api = {
  install (Vue, options) {
    // API INSTANCE
    Vue.prototype.$api = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      timeout: 30000,
      withCredentials: true
    })

    // RETRY SETTINGS
    // axiosRetry(Vue.prototype.$api, {
    //   retries: 3,
    //   shouldResetTimeout: true,
    //   retryDelay: axiosRetry.exponentialDelay,
    //   retryCondition: axiosRetry.isSafeRequestError
    // })

    // REQUEST HOOKS
    // - Token Authentication
    Vue.prototype.$api.interceptors.request.use(
      function (config) {
        let token = Cookie.get('token')
        let customerToken = Cookie.get('customer_token')
        if (token) { 
          config.headers['Authorization'] = 'Bearer ' + token 
        } else if (customerToken) { 
          config.headers['Authorization'] = 'Bearer ' + customerToken 
        }
        return config
      },
      function (error) {
        return Promise.reject(error)
      }
    )
    
    // RESPONSE HOOKS
    // - Handle Authentication Errors
    Vue.prototype.$api.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response && error.response.status === 401) {
        Store.commit('logout')
        Store.dispatch('customer/logout')
        Cookie.remove('token')
        Cookie.remove('customer_token')
        window.location.href = '/'
      }

      return Promise.reject(error)
    })
  }
}

Vue.use(api)